<template>
  <modal-card ref="modal">
    <h2 class="title is-4">Approve Application</h2>
    <h6 class="subtitle is-6">You are about to approve this application</h6>
    <b-checkbox v-model="checkbox">Send approval email to the applications</b-checkbox>
    <div class="buttons">
      <button class="button is-primary " @click="handleApprove()">
        Approve Applicant
      </button>
      <button class="button" type="button" @click="closeModal()">Close</button>
    </div>
  </modal-card>
</template>

<script>

import { approveApplicationMutation } from '../../graphql/applications'
import ModalCard from '../ModalCard.vue'

export default {
  name: 'Applicant',
  components: {
    ModalCard
  },
  data () {
    return {
      checkbox: true
    }
  },
  props: {
    applicant: Object
  },
  methods: {
    handleApprove () {
      // reset action
      this.$apollo.mutate({
        mutation: approveApplicationMutation,
        variables: {
          id: this.applicant.id,
          suppressEmail: this.checkbox
        }
      })
        .then(() => {
          this.$toast.open({
            message: 'Application Approved!',
            type: 'is-success'
          })
          // redirect to the applications page
          this.$router.push({ name: 'applications' })
          // close modal
          this.closeModal()
        })
        .catch((e) => {
          this.$toast.open({
            message: 'Failed to approve!<br>' + (e.message || e),
            type: 'is-danger',
            duration: 5000
          })
          // close modal
          this.closeModal()
        })
    },
    closeModal () {
      // close modal
      this.$refs.modal.close()
      // reset form
      this.checkbox = true
    }
  }
}
</script>
